<template>
    <div>
        <div v-if="!configModalEditPage.model" class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div v-if="isPageTypeId">
                    <div class="form-group row">
                        <div class="col-sm-10">
                            <div v-for="(master_page, idx) in settingPageForm.setting_page.pages" :key="idx">
                                <div class="form-group row">
                                    <div class="col-sm-6" :style="`opacity: ${master_page?.is_disabled ? '0.5' : '1'}`">
                                        <label
                                            class="text-nowrap p-2"
                                            style="width: 100%; background-color: #dadad9; font-weight: 900; min-width: fit-content"
                                            >{{ master_page.title }}</label
                                        >
                                        <div v-for="(page, k) in master_page.page_child" :key="k">
                                            <label
                                                class="col-sm-3 mt-2"
                                                :style="`min-width: 150px; cursor:${master_page?.is_disabled ? 'not-allowed' : 'pointer'}; color: #5664d2; max-width: 100%`"
                                                @click="handleEditFormInput(master_page, page, idx, k)"
                                            >
                                                {{ page.name_page }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.specifiedNumberOfApplicationsEndScreen')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.specified_number_of_applications_end_screen"
                                    :id="`check-specifiedNumberOfApplicationsEndScreen`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.screenBeforeApplicationPeriodStarts')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.screen_before_application_period_starts"
                                    :id="`check-screenBeforeApplicationPeriodStarts`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                $t('managerForm.settingPage.applicationPeriodEndScreen')
                            }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.application_period_end_screen"
                                    :id="`check-applicationPeriodEndScreen`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.unknownError') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox
                                    :model.sync="settingPageForm.setting_page.unknown_error"
                                    :id="`check-unknownError`"
                                    :value="false"
                                    :label="``"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.login') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox :model.sync="settingPageForm.setting_page.login" :id="`check-login`" :value="false" :label="``" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.mypage') }}</label>
                            <div class="col-sm-9">
                                <InputCheckBox :model.sync="settingPageForm.setting_page.my_page" :id="`check-Mypage`" :value="false" :label="``" />
                            </div>
                        </div>
                    </div> -->
                </div>
            </form>
        </div>
        <modalEditPage ref="modalEditPage" :dataForm="dataForm" :configModal="configModalEditPage" />
    </div>
</template>

<script>
import { configModalEditPage } from '../../../components/setting-page/constants';
// import { InputRadio, InputCheckBox } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';

import modalEditPage from './components/modal-edit-page.vue';

export default {
    name: 'SettingPage',
    components: {
        modalEditPage
        // InputCheckBox,
        // InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    computed: {
        isPageTypeId() {
            return this.dataForm.page_type?.id ? true : false;
        }
    },
    data() {
        return {
            configModalEditPage: configModalEditPage(),
            settingPageForm: this.dataForm
        };
    },
    methods: {
        ...managerFormMethods,

        handleEditFormInput(master_obj, obj, idx, k) {
            if (master_obj?.is_disabled) return;
            this.configModalEditPage.model = true;
            this.configModalEditPage.id = `edit_page-${idx}_${k}`;
            this.configModalEditPage.title = obj.name_page;
            this.configModalEditPage.parentPage = master_obj;
            this.configModalEditPage.childPage = obj;
            this.updateBlockList(obj.blocks);
            this.updateButtonEvent({ eventEditPage: true });
        },

        onHandleCloseSettingBlock() {
            this.configModalEditPage.model = false;
        }
    },

    watch: {
        dataForm: {
            handler(newVal) {
                this.settingPageForm = newVal;
            },
            deep: true
        },

        'dataForm.setting_lottery': {
            handler(newVal) {
                this.settingPageForm.setting_page.pages.forEach((page) => {
                    if (page.title === '落選画面') {
                        page.is_disabled = newVal?.is_prize_before_the_draw;
                    }
                });
                this.idxChangePropertiesPage++;
            },
            immediate: true,
            deep: true
        }
    },

    mounted() {}
};
</script>

<style lang="scss" scoped>
.popupw {
    font-size: 20px;
    &:hover {
        opacity: 0.8;
    }
}
.namePage {
    &:hover {
        opacity: 0.7;
    }
}
</style>
